import produce from 'immer'

const INITIAL_STATE = {
  currentTheme: 'light',
  currentThemeSelected: 'light',
}

export default (state = INITIAL_STATE, action) =>
  produce(state, draft => {
    const newDraft = draft

    switch (action.type) {
      case '@theme/SET_CURRENT_THEME': {
        newDraft.currentTheme = action.payload.currentTheme
        break
      }

      case '@theme/SET_CURRENT_THEME_SELECTED': {
        newDraft.currentThemeSelected = action.payload.currentThemeSelected
        break
      }

      default:
    }
  })
